import { VOICE_KINDS, type VoiceKind } from './recorded';

export const VOICE_KEY = 'dale.agents.voz';

export type VoicePreference = 'off' | VoiceKind;

/** The owner's choice, kept in this browser. It starts off: a work tool does not talk until asked to. */
export function readVoicePreference(): VoicePreference {
  try {
    const stored = window.localStorage.getItem(VOICE_KEY);
    if (stored === 'on') return 'mujer'; // the first version's switch, which read aloud with the browser's voice
    return VOICE_KINDS.find((kind) => kind === stored) ?? 'off';
  } catch {
    return 'off';
  }
}

export function saveVoicePreference(voice: VoicePreference): void {
  try {
    window.localStorage.setItem(VOICE_KEY, voice);
  } catch {
    // Private windows: the choice lasts this visit.
  }
}
